/** PostDetailVisibility のキー一覧 (admin form / parser / merge の単一情報源)。 */
export const POST_DETAIL_VISIBILITY_KEYS = [
    'classificationAxes',
    'assessment',
    'aggregateScores',
    'fieldsTable',
];
/**
 * テンプレ既定 ← 地区上書き の順で可視性を解決する (issue #24)。
 *
 * 解決規則: 各キーについて `地区上書き ?? テンプレ既定 ?? true`。
 * いずれも未指定なら `true` (表示) = 既存挙動を変えない後方互換。
 */
export function resolvePostDetailVisibility(templateDefault, districtOverride) {
    const pick = (k) => districtOverride?.[k] ?? templateDefault?.[k] ?? true;
    return {
        classificationAxes: pick('classificationAxes'),
        assessment: pick('assessment'),
        aggregateScores: pick('aggregateScores'),
        fieldsTable: pick('fieldsTable'),
    };
}
/**
 * 任意の `unknown` を安全に PostDetailVisibility に変換する。boolean 以外のキーは捨てる。
 * 1 つも有効キーが無ければ `undefined` (= 未設定扱い、後方互換)。
 */
export function parsePostDetailVisibility(raw) {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
        return undefined;
    const rec = raw;
    const out = {};
    for (const k of POST_DETAIL_VISIBILITY_KEYS) {
        if (typeof rec[k] === 'boolean')
            out[k] = rec[k];
    }
    return Object.keys(out).length > 0 ? out : undefined;
}
//# sourceMappingURL=postDetailVisibility.js.map